<template>
  <div :class="classStyle" :title="titleText" class="misans">
    {{value===null?'-':transMoney(value)||0}}
  </div>
</template>

<script>
import {filterMoeny} from '@/assets/utils/currencyFormat'
export default {
    props:{
        value:{
            type:[Number,String],
        },
        classStyle:{
            type:[Array],
            default:()=>['f-18','overflow_ellipsis','misansBold']
        },
        title:{
            type:Boolean,
            default:true
        },
        // 1/2   万以下显示整数万以上万为单位  /  千分位
        transType:{
            type:String,
            default:'1'
        }
    },
    data(){
        return {
            titleText:''
        }
    },
    watch:{
        value:{
            handler(val){
                if(this.title) this.titleText = val
            },
            immediate:true
        },
    },
    methods:{
        transMoney(value){
            if(this.transType==1){
                return filterMoeny(value)
            }else if(this.transType==2){

            }else {

            }
        },
    },
}
</script>
   
<style lang='less' scoped>
 @import '../../assets/css/misans/misans.css';
    .f-18 {
		font-size: 18px;
        font-weight: bold;
	}
    .overflow_ellipsis {
		white-space:nowrap;
       	overflow:hidden;
        text-overflow:ellipsis;
	}

</style>


// WEBPACK FOOTER //
// src/components/moneys/index.vue